"use client";

import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import styles from "./TattooAftercare.module.css";
import tattoo1 from "../../images/tattoo1.webp";
import tattoo2 from "../../images/tattoo2.webp";
import tattoo3 from "../../images/tattoo3.webp";
import tattoo4 from "../../images/tattoo4.webp";
import tattoo5 from "../../images/tattoo5.webp";
import tattoo6 from "../../images/tattoo6.webp";
import tattoo7 from "../../images/tattoo7.webp";

const healedTattoos = [
  { id: 1, src: tattoo1, healingTime: "2 months" },
  { id: 2, src: tattoo2, healingTime: "2 years" },
  { id: 3, src: tattoo3, healingTime: "1 week" },
  { id: 4, src: tattoo4, healingTime: "6 months" },
  { id: 5, src: tattoo5, healingTime: "1 year" },
  { id: 6, src: tattoo6, healingTime: "1 year" },
  { id: 7, src: tattoo7, healingTime: "1.5 years" },
];

function useParallax(value, distance) {
  return useTransform(value, [0, 1], [-distance, distance]);
}

function HealedTattoo({ src, healingTime }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref });
  const y = useParallax(scrollYProgress, 300);

  return (
    <section className={styles.imgContainer}>
      <div ref={ref} className={styles.imageBox}>
        <img src={src} alt="Healed Tattoo" />
      </div>
      <motion.h2
        initial={{ visibility: "hidden" }}
        animate={{ visibility: "visible" }}
        style={{ y }}
        className={styles.parallaxText}
      >
        {healingTime}
      </motion.h2>
    </section>
  );
}

const TattooAftercare = () => {
  return (
    <div className={styles.pageWrapper}>
      <h1 className={styles.pageTitle}>Tattoo Aftercare</h1>

      <section className={styles.instructions}>
        <h2>Aftercare Supplies</h2>
        <ul>
          <li>Unscented soap, antibacterial optional</li>
          <li>Aquaphor or unscented lotion</li>
        </ul>
        <p>
          Many factors can affect how a tattoo heals, including the style of
          tattoo, technical application, your age, ambient humidity, and how you
          take care of it while healing! Two weeks is the minimum amount of time
          before a tattoo is fully healed, some will heal faster or slower.
        </p>
        <p>
          A bandage will always be applied to your new tattoo upon leaving the
          tattoo studio. You will be given specific instructions on how/when to
          remove the bandage, depending on what type of bandage we use. Do not
          re-bandage your tattoo after removing the initial bandage. Once
          removed, wash with warm water and soap using clean hands. Pat dry with
          a clean towel and let it air dry.
        </p>
        <p>
          Once your tattoo is dry, apply a thin layer of Aquaphor or unscented
          lotion—do not overapply. Always wash hands immediately before touching
          your new tattoo.
        </p>
        <p>
          Clean your tattoo twice a day and moisturize 2–3 times daily for at
          least two weeks or until fully settled. You can resume exercise in 1–2
          days. Cover the healing area and clean it after workouts.
        </p>
      </section>
            <section className={styles.avoid}>
        <h2>What To Avoid While Healing:</h2>
        <ul>
          <li>No swimming or soaking</li>
          <li>Avoid contact with any gym equipment/benches</li>
          <li>Avoid prolonged direct sun exposure</li>
          <li>Avoid contact with pets, animal hair, etc.</li>
          <li>Be mindful of clothing/attire rubbing against the tattoo</li>
        </ul>
      </section>
      {/* Local scroll container with snap */}
      <section className={styles.gallerySection}>
        <h2 className={styles.healedTitle}>Healed</h2>
        <div className={styles.snapWrapper}>
          {healedTattoos.map((item, index) => (
            <HealedTattoo
              key={item.id}
              src={item.src}
              healingTime={item.healingTime}
              reverse={index % 2 !== 0}
            />
          ))}
        </div>
      </section>
    </div>
  );
};

export default TattooAftercare;
